import { MonoBehavior } from './core/monoBehavior';
import { translate } from 'game/translate';
import { SoundManager } from 'game/core/soundManager';
import { Store } from './store/gameStore';
import { GameEvent } from './events/gameEvent';
import { EventName } from './events/eventsName';
import { openFeedbackPopup } from './feedback';
import { GAEvent, GAEventNames } from './analytics/events';
import { showPopup } from './showPopup';
import { isIOS } from './core/display';
import { GameLog } from './helpers/debug';
import { KingPopup } from './KingPopup';
import { isMobile } from 'pixi.js';

export class WinScreen extends MonoBehavior {
    constructor() {
        super();
        addEventListener('showWinScreen', (e: CustomEvent) => {
            localStorage.clear();
            GameLog('showWinScreen wins:', e.detail);
            Store.mockFeedbackOnWin(parseInt(e.detail));
            this.showWinScreen(e);
        });
        GameEvent.add(EventName.RESET_GAME, this.hideWinScreen.bind(this));
        GameEvent.add(EventName.SHOW_WIN_AFTER_FEEDBACK, this.displayWinScreen.bind(this));
        GameEvent.add(EventName.CLOSE_MODAL, this.onModalsHide.bind(this));
    }
    onModalsHide(e: { id: string; confirm: boolean }) {
        const { id, confirm } = e;
        if (id === 'push_notifications') {
            if (confirm) {
                Store.notificationWinPopupNextShow = -1;
                Store.gameStorage.setItem('notificationWinPopupNextShow', Store.notificationWinPopupNextShow);
                GAEvent(GAEventNames.NOTIFICATION_POPUP_SUBSCRIBE, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.wins,
                    name: Store.name,
                });
                new KingPopup('thanksSubscribing');
            } else {
                Store.notificationWinPopupNextShow += 20;
                Store.gameStorage.setItem('notificationWinPopupNextShow', Store.notificationWinPopupNextShow);

                GAEvent(GAEventNames.NOTIFICATION_POPUP_SKIP, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.notificationWinPopupNextShow,
                    name: Store.name,
                });
            }
            this.displayWinScreen();
        }
        if (id === 'facebook-banner') {
            if (confirm) {
                Store.facebookWinPopupNextShow = -1;
                Store.gameStorage.setItem('facebookWinPopupNextShow', Store.facebookWinPopupNextShow);

                Store.setWandCounter(Store.wandCounter + 5);
                GAEvent(GAEventNames.FACEBOOK_BANNER_FOLLOW, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.wins,
                    name: Store.name,
                });

                const url = 'https://www.facebook.com/solitairescom';
                if (isIOS()) window.location.href = url;
                else window.open(url, '_blank');
            } else {
                GameLog('Facebook banner closed');
                GAEvent(GAEventNames.FACEBOOK_BANNER_CLOSE, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.facebookWinPopupNextShow,
                    name: Store.name,
                });
            }
            this.displayWinScreen();
        }
    }
    hideWinScreen() {
        const popup = document.getElementById('win-popup-wrapper');
        if (popup) {
            popup.classList.remove('active');
        }
    }
    displayWinScreen() {
        SoundManager.play('winPopupSFX');
        const popup = document.getElementById('win-popup-wrapper');

        if (popup) {
            popup.classList.add(`win-popup-game-${Store.name}`);
            popup.classList.add('active');
            const scoreValue = document.getElementById('win-popup-score');
            const scoreLabel = document.getElementById('win-popup-score-label');

            if (scoreValue && scoreLabel) {
                scoreValue.innerText = Store.score.toString();
                scoreLabel.innerText = translate('score') + ':';
            }

            const timeValue = document.getElementById('win-popup-time');
            const timeLabelLabel = document.getElementById('win-popup-time-label');
            timeValue!.innerText = Store.getTimeFormat();
            timeLabelLabel!.innerText = translate('time') + ':';

            const movesValue = document.getElementById('win-popup-moves');
            const movesLabel = document.getElementById('win-popup-moves-label');
            movesValue!.innerText = Store.movesCount.toString();
            movesLabel!.innerText = translate('moves') + ':';

            const buttonLabel = document.getElementById('win-popup-button-label');
            buttonLabel!.innerText = translate('newDeal');

            const button = document.getElementById('win-popup-button');
            if (button) {
                button.onclick = () => {
                    dispatchEvent(new CustomEvent('newWinGame'));
                };
            }
        }
    }
    showWinScreen(e?: CustomEvent) {
        if (e) {
            const wins = parseInt(e.detail);
            Store.wins = wins;
        }

        if (Store.showFeedbackOnWin()) {
            openFeedbackPopup('win');
            return;
        }
        if ('Notification' in window && Store.isMobile) {
            if (
                Store.notificationWinPopupNextShow !== -1 &&
                Store.wins >= Store.notificationWinPopupNextShow &&
                Notification.permission === 'default'
            ) {
                showPopup('push_notifications');

                GAEvent(GAEventNames.NOTIFICATION_POPUP_SHOW, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.notificationWinPopupNextShow,
                    name: Store.name,
                });
                return;
            }
        }

        if (
            Store.language === 'en' &&
            Store.facebookWinPopupNextShow !== -1 &&
            Store.wins >= Store.facebookWinPopupNextShow
        ) {
            showPopup('facebook-banner');
            GAEvent(GAEventNames.FACEBOOK_BANNER_VIEW, {
                type: Store.getGameTypeText(),
                difficulty: Store.getDifficultyText(),
                number: Store.facebookWinPopupNextShow,
                name: Store.name,
            });

            Store.facebookWinPopupNextShow += 20;
            Store.gameStorage.setItem('facebookWinPopupNextShow', Store.facebookWinPopupNextShow);
            return;
        }

        this.displayWinScreen();
    }
}
